import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseGetInvalidateQuery = (options) => {
    const useGetInvalidateQuery = () => {
        const client = useQueryClient();
        const queryKey = getQueryBaseKey(options, 'query');
        return () => client.invalidateQueries({ queryKey });
    };
    return useGetInvalidateQuery;
};
